<template>
  <div class="upload-image">
    <el-upload
      v-if="isShowUpload"
      :file-list="fileList"
      :disabled="disabled"
      multiple
      :limit="maxCount"
      action="#"
      list-type="picture-card"
      :auto-upload="false"
      @change="uploadChangeHandle"
      @remove="uploadRemoveHandle"
      @exceed="uploadExceedHandle"
      @preview="handlePictureCardPreview"
    >
      <img :src="formatImgFullPath('/other/upload_img.png')" class="upload_img" />
    </el-upload>

    <el-dialog v-model="dialogVisible">
      <img style="width: 100%" :src="dialogImageUrl" alt="Preview Image" />
    </el-dialog>
  </div>
</template>

<script setup>
  import { defineProps, nextTick, ref, unref, watchEffect, defineEmits } from 'vue'
  import { formatImgFullPath } from '@/utils'
  import { uploadImage } from '@/api/common'
  import { ElMessage } from 'element-plus'

  const props = defineProps({
    files: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxCount: {
      type: Number,
      default: 5
    },
    maxSize: {
      type: Number,
      default: 2
    }
  })
  const emits = defineEmits(['update:files', 'change'])

  const dialogImageUrl = ref('')
  const dialogVisible = ref(false)

  const fileList = ref([])
  const isShowUpload = ref(true)
  const uploadChangeHandle = async file => {
    if (beforeAvatarUpload(file.raw)) {
      fileList.value.push(file)
      const result = await uploadImage(file)
      const fileIndex = unref(fileList).findIndex(i => i.uid === file.uid)

      if (!result?.url) return fileList.value.splice(fileIndex, 1)

      if (fileIndex >= 0) {
        fileList.value[fileIndex] = {
          ...unref(fileList)[fileIndex],
          status: 'success',
          url: result.url ?? ''
        }
      }
      fileChangeHandle()
    }

    isShowUpload.value = false
    nextTick(() => (isShowUpload.value = true))
  }
  const uploadRemoveHandle = file => {
    const url = file.url
    if (!url) return
    const index = fileList.value.findIndex(item => item.url === url)
    if (index >= 0) fileList.value.splice(index, 1)
    fileChangeHandle()
  }

  const beforeAvatarUpload = rawFile => {
    if (!['image/jpeg', 'image/png', 'image/gif'].includes(rawFile.type)) {
      ElMessage.error('图片格式错误')
      return false
    } else if (rawFile.size / 1024 / 1024 > props.maxSize) {
      ElMessage.error(`最大图片大小不能超过${props.maxSize}MB!`)
      return false
    }
    return true
  }

  const uploadExceedHandle = () => {
    ElMessage.error(`最多只能上传${props.maxCount}张图片`)
  }

  const handlePictureCardPreview = file => {
    dialogImageUrl.value = file.url
    dialogVisible.value = true
  }

  const fileChangeHandle = () => {
    const list = unref(fileList).map(i => i.url)
    emits('update:files', list)
    emits('change', list)
  }

  let isInit = true
  watchEffect(() => {
    if (isInit) {
      isInit = false
      fileList.value = props.files.map((file, index) => ({
        name: file,
        status: 'success',
        uid: index,
        url: file
      }))
    }
  })
</script>

<style lang="scss" scoped>
  .upload-image {
    :deep(.el-upload-list) {
      --el-upload-list-picture-card-size: 66px;

      .el-upload--picture-card {
        --el-upload-picture-card-size: 66px !important;
      }
    }
  }

  .upload_img {
    border: 1px solid #e8e8e8;
  }
</style>
